import { Box } from '@mui/system';
import axios from 'axios';
import { useState } from 'react';
import { useQuery } from '../../../hooks/UseQuery';
import TController from './create/TController';
import useGetData from './helpers/useGetData';
import { Loader } from '../../../components/common/Loader';
import HeaderCreate from './HeaderCreate';
import { moduleConstant } from './constant';
import useConfirm from '../../../components/common/useConfirm';

interface MyData {
  moduleData: any;
  isLoading: boolean;
  setModuleData: any;
  setRenderforUpdate: any;
  setParentRender: React.Dispatch<React.SetStateAction<boolean>>;
  error?: string | null;
  machineData: any;
  handleImport: any;
}
const Create = () => {
  const date = useQuery('date');
  // const isView = useQuery('isView') === 'true' ? true : false;
  const [isView, setisView] = useState<boolean>(false);
  const [DialogUpdate, confirmUpdate] = useConfirm(
    'Save',
    'Are you sure you want to save?'
  );
  const [DialogDelete, confirmDelete] = useConfirm(
    'DELETE',
    'Are you sure you want to delete this row?'
  );
  const [DialogImport, confirmImport] = useConfirm(
    'Import',
    'Are you sure you want to import this document?'
  );

  const {
    error,
    moduleData,
    setModuleData,
    isLoading,
    setParentRender,
    setRenderforUpdate,
    machineData,
    handleImport,
  }: MyData = useGetData();
  // const handleImport = async () => {
  //   const ans = await confirmImport();
  //   if (!ans) return;

  //   try {
  //     const response = await axios.get(
  //       `/api/downTimeAnalysisRoute/importMonthlyData/getData?date=${date}`
  //     );
  //     const locationResponse = await axios.get(
  //       `/api/machineRoutes/machine/ForAutocomplete`
  //     );
      
  //     // Create a map for quick access to location models by machine_id
  //     const locationMap :any= {

  //     };
  //     locationResponse.data.forEach((machine:any) => {
  //       locationMap[machine._id] = machine.locationModel_id; // Assuming each machine has a locationModel_id
  //     });
  //     for (const item of response?.data || []) {
  //       const machineId = item?.machine_id?._id;
  
  //       // Check if the machineId exists in the locationMap
  //       if (locationMap[machineId]) {
  //         // Set the locationModel_id object inside the machine_id
  //         item.machine_id.locationModel_id = locationMap[machineId];
  //       } else {
  //         // If not found, set a default empty locationModel_id object
  //         item.machine_id.locationModel_id = { _id: null, location_name: '' };
  //       }
  
  //       const index = moduleData.findIndex(
  //         (obj:any) => obj?.machine_id?._id === machineId
  //       );
  
  //       if (index === -1) {
  //         moduleData.push({ ...item });
  //       } else {
  //         moduleData[index] = {
  //           ...moduleData[index],
  //           ...item,
  //         };
  //       }
  //     }
  //     // response?.data?.forEach((item: any) => {
  //     //   const machineId = item?.machine_id?._id;
  //     //   const index = moduleData.findIndex(
  //     //     (obj: any) => obj?.machine_id?._id === machineId
  //     //   );
  //     //   if (index === -1) {
  //     //     moduleData.push({ ...item });
  //     //   } else {
  //     //     moduleData[index] = {
  //     //       ...moduleData[index],
  //     //       ...item,
  //     //     };
  //     //   }
  //     // });
      
  //     setModuleData([...moduleData]); // Update state with a new object reference
  //     console.log("module data is",moduleData);
  //     alert('Imported Successfully');
  //   } catch (error) {
  //     alert('Down Time Analysis Report Not exist !!!');
  //     console.error(error);
  //   }
  // };

  const handleUpdate = async () => {
    if (!date) {
      alert('date required');
      return;
    }
    const ans = await confirmUpdate();
    if (!ans) return;

    axios
      .post(`${moduleConstant.apiConstant}?date=${date}`, moduleData)
      .then((res) => {
        setRenderforUpdate((prev: any) => !prev);
        alert('successfully updated');
      })
      .catch((err) => console.error(err));
  };

  const handleDelete = async (id: string, rowIndex: number) => {
    const ans = await confirmDelete();
    if (!ans) return;
    if (!id) {
      const values = [...moduleData];
      values.splice(rowIndex, 1);
      setModuleData(values);
      alert('row deleted successfully');
      return;
    }
    await axios
      .delete(`${moduleConstant.apiConstant}/${id}`)
      .then((res) => {
        if (res.data) {
          const values = [...moduleData];
          values.splice(rowIndex, 1);
          setModuleData(values);
          alert('row deleted successfully');
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <Box>
      <Loader loader={isLoading} />
      <HeaderCreate
        {...{
          handleUpdate,
          moduleData,
          setModuleData,
          handleImport,
        }}
      />
      <TController
        {...{
          moduleData,
          isView,
          handleDelete,
          setModuleData,
          setParentRender,
          machineData,
        }}
      />
      <DialogUpdate isSubmitContent={false} />
      <DialogDelete isSubmitContent={false} />
      <DialogImport />
    </Box>
  );
};

export default Create;
